import {format} from "date-fns";
import React, {Component} from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApiConnect from "../../../Utils/ApiConnect";
import QuickView from "../../Components/QuickView";

class Transaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewData: [],
      loading: true,
      startDate: new Date(),
      endDate: new Date(),
      showModal: false,
      PreviewID: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Order Date",
        selector: row => row.date,
        sortable: true,
      },
      {
        name: "Table Date",
        selector: row => row.table_date,
        sortable: true,
      },
      {
        name: "Order Id",
        selector: row => row.id,
        sortable: true,
        cell: (row) => {
          return (
            <React.Fragment>
              {" "}
              <a
                onClick={() => {
                  this.setState({
                    showModal: true,
                    PreviewID: row.id,
                  });
                }}
                href="#_"
              >
                {row.id}
              </a>
              {row.membership !== "0" ? (
                <span className="material-icons-outlined text-success">
                  contact_mail
                </span>
              ) : (
                ""
              )}
              {row.promo !== "0" ? (
                <span className="material-icons-outlined text-success">
                  local_activity
                </span>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        },
      },
      {
        name: "Table",
        selector: row => row.table,
        sortable: true,
      },
      {
        name: "Discount",
        selector: row => row.discount,
        sortable: true,
      },
      {
        name: "Amount",
        selector: row => row.total,
        sortable: true,
      },
      {
        name: "Items",
        selector: row => row.items,
        sortable: true,
      },
      {
        name: "Payment",
        selector: row => row.payment_type,
        sortable: true,
      },
      {
        name: "Waiter/Users",
        selector: row => row.waiter,
        sortable: true,
        cell: (row) => {
          return (
            <React.Fragment>
              <div className="avatar-list avatar-list-overlap">
                <a className="avatar" href="#_">
                  <img src={row.waiter.avatar} alt={row.waiter.name} />
                </a>
                <a className="avatar" href="#_">
                  <img src={row.cashier.avatar} alt={row.cashier.name} />
                </a>
              </div>
              <button
                className="table-action btn btn-square btn-pure hover-warning"
                onClick={() => {
                  this.setState({
                    showModal: true,
                    PreviewID: row.id,
                  });
                }}
              >
                <span className="material-icons-outlined">visibility</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  GetTransactionData() {
    ApiConnect.get(
      `/POS/Report/Transaction?from=${format(
        this.state.startDate,
        "yyyy-MM-dd"
      )}&to=${format(this.state.endDate, "yyyy-MM-dd")}`
    )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({ viewData: response.data.data, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  SetshowQuick = () => {
    this.setState({ showModal: false });
  };
  render() {
    const filteredData = this.state.viewData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <div className="card">
        <div className="card-header pl-3 pr-3">
          <h4>Transaction</h4>
          <div className="input-group">
            <label htmlFor="start">From Date</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              className="form-control"
              maxDate={new Date()}
              closeOnScroll={true}
              selected={this.state.startDate}
              value={this.state.startDate}
              onChange={(e) => this.setState({ startDate: e })}
              placeholderText="Start Date"
            />
          </div>
          <div className="input-group">
            <label htmlFor="start">To Date</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              className="form-control"
              maxDate={new Date()}
              closeOnScroll={true}
              selected={this.state.endDate}
              value={this.state.endDate}
              onChange={(e) => this.setState({ endDate: e })}
              placeholderText="End Date"
            />
          </div>
          <button
            className="btn btn-info"
            onClick={(e) => this.GetTransactionData()}
          >
            Fetch
          </button>
        </div>
        <div className="card-body pl-3 pr-3">
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              onChange={e => this.setState({ filterText: e.target.value })}
            />
          </div>
          <DataTable
            className="table"
            keyField="id"
            columns={this.columns}
            data={filteredData}
            pagination
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            paginationPerPage={10}
            customStyles={this.customStyles}
            filter
            exportable
            loading={this.state.loading}
          />
          <hr className="hr-sm w-100 mr-0" />
          <table className="table table-borderless text-center">
            <tbody>
              <tr className="d-flex col-12">
                <td className="col">Cash</td>
                <td className="col text-right">
                  {" "}
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                      (sum +=
                        i.payment_type === "Cash" ? parseFloat(i.total) : 0),
                      0
                    )
                  )}
                </td>
                <td className="col text-right">Card</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                      (sum +=
                        i.payment_type === "Card" ? parseFloat(i.total) : 0),
                      0
                    )
                  )}
                </td>
              </tr>

              <tr className="d-flex col-12">
                <td className="col">Fonepay</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                      (sum +=
                        i.payment_type === "Fonepay"
                          ? parseFloat(i.total)
                          : 0),
                      0
                    )
                  )}
                </td>

                <td className="col text-right">Account</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                      (sum +=
                        i.discount === "Account" ? parseFloat(i.total) : 0),
                      0
                    )
                  )}
                </td>
              </tr>
              <tr className="d-flex col-12">
                <td className="col">NepalPay</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                      (sum +=
                        i.payment_type === "NepalPay"
                          ? parseFloat(i.total)
                          : 0),
                      0
                    )
                  )}
                </td>
                <td className="col text-right">Promo Code</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                      (sum +=
                        i.payment_type === "Account"
                          ? parseFloat(i.total)
                          : 0),
                      0
                    )
                  )}
                </td>
              </tr>
              <tr className="d-flex col-12">
                <td className="col">Discount</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum += i.discount ? parseFloat(i.discount) : 0),
                      0
                    )
                  )}
                </td>

                <td className="col">Membership</td>
                <td className="col text-right">
                  रु{" "}
                  {parseFloat(
                    this.state.viewData.reduce(
                      (sum, i) =>
                        (sum += i.discount ? parseFloat(i.discount) : 0),
                      0
                    )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <QuickView
            trigger={this.state.showModal}
            type="Sales Entry"
            id={this.state.PreviewID}
            hideTrigger={this.SetshowQuick}
          />
        </div>
      </div>
    );
  }
}
export default Transaction;
